import { PasseriniAPI } from './apiService';

export const deleteGroup = async (id) => {
  const response = await PasseriniAPI.delete(`/peoplegroups/${id}`);
  return response.data;
}

export const createGroup = async (group) => {
  const response = await PasseriniAPI.post('/peoplegroups', group);
  return response.data;
}

export const updateGroup = async (group) => {
  const response = await PasseriniAPI.put(`/peoplegroups/${group.id}`, group);
  return response.data;
}

export const getGroup = async (id) => {
  const response = await PasseriniAPI.get(`/peoplegroups/${id}`);
  return response.data;
}
